export default __webpack_public_path__ + "static/media/pangong5.1326a4a3.jpg";